(() => {
  if (window.wvShelfColoursReady) return;
  window.wvShelfColoursReady = true;
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-shelf-size]');
    if (!choice || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = choice.closest('[data-shelf-card]');
    if (!card) return;
    event.preventDefault();
    card.querySelectorAll('[data-shelf-size]').forEach((link) => {
      link.classList.toggle('is-selected', link === choice);
      if (link === choice) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    card.querySelectorAll('[data-shelf-destination]').forEach(link => link.href = choice.href);
    const image = card.querySelector('.wv-shelf-colours__image img');
    if (image) {
      image.removeAttribute('srcset');
      image.src = choice.dataset.photo;
      image.alt = choice.dataset.alt;
    }
    card.querySelector('[data-shelf-price]').textContent = choice.dataset.price;
    card.querySelector('[data-shelf-availability]').textContent = choice.dataset.availability;
  });
})();
